module.exports = __webpack_public_path__ + "static/userMessage-0fe35bd29c309e4a60942169e85340a1.gif";